/**
 * Composant tampon pour react-intl.
 *
 * Re-exporte toute l'API de react-intl et fournit le HOC `injectIntl`, retire en react-intl >= 7
 * au profit du hook `useIntl`. Indispensable ici : la majorite des composants sont des classes
 * (hooks impossibles) et recuperent la locale via `this.props.intl`. Les composants importent
 * `injectIntl` / `FormattedMessage` / `IntlProvider` d'ici, si bien qu'un futur changement de
 * react-intl ne touchera que ce fichier.
 */
import React from 'react';
import { useIntl } from 'react-intl';

export * from 'react-intl';

export function injectIntl(WrappedComponent) {
    function WithIntl(props) {
        const intl = useIntl();
        return <WrappedComponent {...props} intl={intl} />;
    }
    WithIntl.displayName = `injectIntl(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    WithIntl.WrappedComponent = WrappedComponent;
    return WithIntl;
}
